import { Observable } from "rxjs";
import { httpClient, Service } from "./client";
import { FeatureSet } from "../models/Offerings/featureSet";
import { IFeatureSet } from "@nendaTypes/NendaTypes";

class OfferingsService extends Service {
  //feature sets
  getFeatureSets(searchQuery?: string): Observable<IFeatureSet[]> {
    return httpClient.get(
      `/offerings/featureSets${searchQuery ? "?searchQuery=" + searchQuery : ""}`,
      this.authHeader()
    );
  }

  getFeatureSet(id: string): Observable<IFeatureSet> {
    return httpClient.get(`/offerings/featureSets/${id}`, this.authHeader());
  }

  createFeatureSet(name: string): Observable<IFeatureSet> {
    return httpClient.post(
      `/offerings/featureSets`,
      {
        externalId: name,
        name: name,
        externalRef: name,
      },
      this.authHeader()
    );
  }

  updateFeatureSet(featureSet: FeatureSet): Observable<IFeatureSet> {
    return httpClient.put(
      `/offerings/featureSets/${featureSet._id}`,
      featureSet,
      this.authHeader()
    );
  }

  deleteFeatureSet(id: string): Observable<void> {
    return httpClient.delete(`/offerings/featureSets/${id}`, this.authHeader());
  }
}

export const offeringsService = new OfferingsService();
